import { isRejectedWithValue } from "@reduxjs/toolkit";
import { captureApiError } from "utils/sentry";

export const sentryErrorMiddleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { endpointName } = action.meta?.arg ?? {};
    const status = action.payload?.status;
    const data = action.payload?.data;
    const args = action.meta?.arg?.originalArgs;

    if (status !== 401) {
      captureApiError(
        new Error(`RTK Query rejected: ${endpointName} (${status})`),
        { endpoint: endpointName, args, status, data }
      );
    }
  }

  return next(action);
};
